module.exports = parcelRequire.resolve("4PTNA");